import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_MIDDLE_END_RESTRICT_CLIENTS = defineFcm('middle_end_restrict_clients')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: {
					type: 'boolean',
				},
				mode: {
					type: 'enum',
					values: ['block', 'warn'],
				},
				allowedClients: {
					type: 'array',
					shape: {
						type: 'string',
					},
				},
				minClientVersions: {
					type: 'record',
					shape: {
						type: 'string',
					},
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		mode: 'block',
		allowedClients: [],
		minClientVersions: {},
	})
	.toConfig();
